<template>
  <div>
    <div v-html="addParagraphs(truncatedBio)"></div>
    <a v-if="displayShowMoreButton" @click.prevent="toggleShowMore" class="teal link hover-teal" href="#">
      {{buttonText}}
    </a>
  </div>
</template>
<script>
  import Vue from 'vue';
  import VueSanitize from 'vue-sanitize';
  Vue.use(VueSanitize);

  export default {
    name: 'ProProfileBio',
    props: {
      proUser: {
        type: Object,
        required: true,
      },
      previewCharacterLimit: {
        type: Number,
        required: false,
        default: 200,
      },
      expandedCharacterLimit: {
        type: Number,
        required: false,
        default: 500,
      },
    },
    computed: {
      characterLimit: function() {
        return this.showMore ? this.expandedCharacterLimit : this.previewCharacterLimit;
      },
      truncatedBio: function() {
        let shortened = this.bio.substr(0, this.characterLimit);
        if (shortened.length < this.bio.length && !this.showMore) {
          const lastSpace = shortened.lastIndexOf(" ");
          if (lastSpace > 0) {
            shortened = shortened.substr(0, Math.min(shortened.length, lastSpace));
          }
          if (!this.showMore) {
            shortened += "...";
          }
        }
        return shortened;
      },
      buttonText: function() {
        return this.showMore ? 'Show Less' : 'Show More';
      },
      displayShowMoreButton: function() {
        return this.bio.length > this.previewCharacterLimit;
      },
      bio: function() {
        return this.proUser.proProfile.bio || '';
      },
    },
    methods: {
      toggleShowMore: function() {
        this.showMore = !this.showMore;
      },
      addParagraphs: function(text) {
        const sanitizedText = this.$sanitize(text);
        const innerHtml = sanitizedText.trim().replace(/\n+/g, '</p><p>');
        return '<p>' + innerHtml + '</p>';
      },
    },
    data() {
      return {
        showMore: false,
      };
    },
  };
</script>
<style scoped>
</style>




// WEBPACK FOOTER //
// src/main/frontend/vue/js/modules/pro/profile/components/ProProfileBio.vue